import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

// Маппинг: ключ -> русское название (по structure-20180828.csv)
const ENRICHMENT_LABELS = {
  actual: 'Действует',
  registration_number: 'Номер регистрации',
  registration_date: 'Дата регистрации',
  application_number: 'Номер заявки',
  application_date: 'Дата подачи заявки',
  priority_date: 'Дата приоритета',
  exhibition_priority_date: 'Дата начала открытого показа экспоната на выставке',
  paris_convention_priority_number: 'Дата первой заявки в государстве-участнике Парижской конвенции по охране промышленной собственности',
  paris_convention_priority_date: 'Номер первой заявки в государстве-участнике Парижской конвенции по охране промышленной собственности',
  paris_convention_priority_country_code: 'Код страны первой заявки в государстве-участнике Парижской конвенции по охране промышленной собственности',
  initial_application_number: 'Номер первоначальной заявки, по которой выделена заявка, по которой выдано свидетельство о государственной регистрации',
  initial_application_priority_date: 'Дата приоритета первоначальной заявки, по которой выделена заявка',
  initial_registration_number: 'Номер первоначальной регистрации, по которой выделена регистрация',
  initial_registration_date: 'Дата первоначальной регистрации, по которой выделена регистрация',
  international_registration_number: 'Номер международной регистрации, преобразованной в национальную заявку на регистрацию',
  international_registration_date: 'Дата международной регистрации, преобразованной в национальную заявку на регистрацию',
  international_registration_priority_date: 'Дата приоритета международной регистрации, преобразованной в национальную заявку на регистрацию',
  international_registration_entry_date: 'Дата внесения записи о территориальном расширении международной регистрации в международный реестр',
  application_number_for_recognition_of_trademark_from_crimea: 'Номер заявки о признании исключительного права на товарный знак с территории Крыма в пределах территории Российской Федерации',
  application_date_for_recognition_of_trademark_from_crimea: 'Дата подачи заявки о признании исключительного права на товарный знак с территории Крыма в пределах территории Российской Федерации',
  crimean_trademark_application_number_for_state_registration_in_ukraine: 'Номер заявки в украинском ведомстве по государственной регистрации товарного знака с территории Крыма на момент воссоединения Крыма с Российской Федерацией',
  crimean_trademark_application_date_for_state_registration_in_ukraine: 'Дата подачи заявки в украинском ведомстве по государственной регистрации товарного знака с территории Крыма на момент воссоединения Крыма с Российской Федерацией',
  crimean_trademark_certificate_number_in_ukraine: 'Номер свидетельства на товарный знак с территории Крыма на момент воссоединения Крыма с Российской Федерацией',
  exclusive_rights_transfer_agreement_registration_number: 'Номер государственной регистрации перехода исключительного права по договору, по которому выдано свидетельство',
  exclusive_rights_transfer_agreement_registration_date: 'Дата государственной регистрации перехода исключительного права по договору, по которому выдано свидетельство',
  legally_related_applications: 'Номера и даты правопреемственных заявок',
  legally_related_registrations: 'Номера и даты правопреемственных регистраций',
  expiration_date: 'Дата окончания срока действия исключительного права',
  right_holder_name: 'Правообладатель',
  foreign_right_holder_name: 'Правообладатель (иностранный)',
  right_holder_address: 'Адрес правообладателя',
  right_holder_country_code: 'Код страны правообладателя',
  right_holder_ogrn: 'ОГРН правообладателя',
  right_holder_inn: 'ИНН правообладателя',
  correspondence_address: 'Адрес для переписки',
  collective: 'Коллективный знак',
  collective_users: 'Лица, имеющие право пользования коллективным товарным знаком',
  extraction_from_charter_of_the_collective_trademark: 'Выписка из устава коллективного товарного знака о единых характеристиках товаров',
  color_specification: 'Описание цвета',
  unprotected_elements: 'Незащищённые элементы',
  kind_specification: 'Вид знака',
  threedimensional: 'Объёмный знак',
  threedimensional_specification: 'Описание объёмного товарного знака',
  holographic: 'Голографический знак',
  holographic_specification: 'Описание голографического товарного знака',
  sound: 'Звуковой знак',
  sound_specification: 'Описание звукового товарного знака',
  olfactory: 'Обонятельный знак',
  olfactory_specification: 'Описание обонятельного товарного знака',
  color: 'Цветной знак',
  color_trademark_specification: 'Описание товарного знака, состоящего только из цвета или нескольких цветов',
  light: 'Световой знак',
  light_specification: 'Описание светового товарного знака',
  changing: 'Изменяемый знак',
  changing_specification: 'Описание изменяемого товарного знака',
  positional: 'Позиционный знак',
  positional_specification: 'Описание позиционного товарного знака',
  publication_url: 'Публикация',
};

// 1. Получить статус (действует/не действует) из enrichment
export function getEnrichmentStatus(enrichment) {
  if (!enrichment || typeof enrichment.actual === 'undefined') return null;
  return enrichment.actual === true || enrichment.actual === 'true' || enrichment.actual === 1 || enrichment.actual === '1';
}

// 2. Получить доп. инфу (все поля кроме actual)
export function getEnrichmentExtraInfo(enrichment) {
  if (!enrichment) return [];
  return Object.entries(enrichment)
    .filter(([key, value]) => key !== 'actual' && value !== '' && value !== null && value !== undefined)
    .map(([key, value]) => ({
      key,
      label: ENRICHMENT_LABELS[key] || key,
      value: value === true ? 'Да' : value === false ? 'Нет' : value,
    }))
    .filter(item => item.value !== 'Нет'); // скрываем поля со значением 'Нет'
}

// 3. React-компонент для отображения доп. инфы
export function EnrichmentDisplay({ extra }) {
  const [visible, setVisible] = useState(false);
  if (!extra || extra.length === 0) return null;

  return (
    <div style={{ marginTop: 8 }}>
      <Button
        type="link"
        icon={<InfoCircleOutlined />}
        onClick={e => {
          e.stopPropagation();
          setVisible(true);
        }}
        style={{
          color: '#1890ff',
          fontWeight: 500,
          padding: 0,
          height: 'auto',
          border: 'none'
        }}
      >
        Показать доп. информацию
      </Button>
      <Modal
        title="Дополнительная информация"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        width={600}
        style={{ position: 'relative' }}
        bodyStyle={{ maxHeight: '400px', overflowY: 'auto' }}
      >
        <div className="theme-preview-muted" style={{ marginTop: 6, borderRadius: 4, padding: 8 }}>
          {extra.map(item => (
            <div key={item.key} style={{ fontSize: 13, marginBottom: 2 }}>
              <b>{item.label}:</b>{' '}
              {item.key === 'publication_url' && item.value ? (
                <a href={item.value} target="_blank" rel="noopener noreferrer">{item.value}</a>
              ) : (
                item.value || '—'
              )}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
} 